const calcularEdad = (fechaNacimiento: Date): number => {
  const today: Date = new Date();

  return Number("" + (today.getMonth() + 1) + (today.getDate() + 1)) >
    Number("" + (fechaNacimiento.getMonth() + 1) + fechaNacimiento.getDate())
    ? today.getFullYear() - fechaNacimiento.getFullYear()
    : today.getFullYear() - fechaNacimiento.getFullYear() + 1;
};

export default calcularEdad;
